import C from 'actionTypes'

export const setContactTypes = data => ({
  type: C.SET_CONTACT_TYPES,
  data
})

export default {
  setContactTypes
}



// WEBPACK FOOTER //
// ./src/actions/contactTypes.js